import script from "./TestResults.vue?vue&type=script&setup=true&lang=js"
export * from "./TestResults.vue?vue&type=script&setup=true&lang=js"

import "./TestResults.vue?vue&type=style&index=0&id=404ebc33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-404ebc33"]])

export default __exports__